// removed by extract-text-webpack-plugin
module.exports = {"container":"_2mbfMUzWQ5By58YaxCHcm7","button":"_1ty6UYVUGpZU_8FPQsplNw"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Snackbar/Snackbar.css
// module id = 995
// module chunks = 58